import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { ButtonTheme, ModalButtons } from '@fcom/ui-components';
@Component({
  selector: 'fin-mmb-unsaved-changes',
  templateUrl: './unsaved-changes.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ManageBookingUnsavedChangesComponent {
  readonly ModalButtons: typeof ModalButtons = ModalButtons;
  readonly ButtonTheme = ButtonTheme;

  @Input() unsavedChangesModalOpen: boolean;

  @Output()
  leaveWithoutSaving: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  continueEditing: EventEmitter<void> = new EventEmitter<void>();
}
